// middleware/user/doctor/register.js
import RestClient from '../../../../api/axiosInterceptor';
import { doctorRegisterActions } from '../../../actions/user/doctor/register';
import { toast } from 'react-toastify';

const createAsyncAction = (actionType, apiCall) => async (dispatch) => {
  try {
    dispatch({ type: actionType.REQUEST });
    const response = await apiCall();
    
    dispatch({
      type: actionType.SUCCESS,
      payload: response.data,
    });

    return response.data; // Return response for handling in component

  } catch (error) {
    let errorMessage = 'Network error or unexpected error occurred';
    let fieldErrors = {};

    if (error.response && error.response.data) {
      // Handle specific field errors
      if (error.response.data.errors) {
        fieldErrors = error.response.data.errors;
        errorMessage = Object.values(fieldErrors)[0]; // Use first error as toast message
      } else if (error.response.data.message) {
        errorMessage = error.response.data.message;
      }
    }

    dispatch({
      type: actionType.FAILURE,
      error: errorMessage,
      fieldErrors: fieldErrors
    });

    // Don't show toast here - let component handle it
    return { error: errorMessage, fieldErrors };
  }
};

export const registerDoctor = (formData, verification_id) => {
  const data = {
    ...formData,
    verification_id,
  };

  return createAsyncAction(
    doctorRegisterActions.REGISTER_DOCTOR,
    () => RestClient.post('/auth1/register', data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
  );
};